<script setup>
import { DropdownMenuSeparator } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  class: { type: String, default: '' },
})
</script>

<template>
  <!--
    `bg-muted` here painted the divider in the muted *text* colour — a near-black
    slate — so every account menu had a heavy dark rule across it. Dividers use
    the hairline token.
  -->
  <DropdownMenuSeparator
    v-bind="props"
    :class="cn('-mx-1 my-1 h-px bg-line', props.class)"
  />
</template>
